import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import SearchIcon from '@mui/icons-material/Search'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import Tooltip from '@mui/material/Tooltip'
import React, { useCallback } from 'react'

import T from 'T'

type ContainerSearchInputProps = {
  value: string
  onChange: (value: string) => void
}

const ContainerSearchInput: React.FC<ContainerSearchInputProps> = ({ value, onChange }) => {
  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value), [onChange])

  return (
    <TextField
      fullWidth
      placeholder={T.SEARCH_PLACEHOLDER}
      size="small"
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" sx={{ color: 'text.secondary' }} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip arrow title={T.SEARCH_CONTAINERS_HINT}>
                <InfoOutlinedIcon fontSize="small" sx={{ color: 'text.secondary' }} />
              </Tooltip>
            </InputAdornment>
          ),
        },
      }}
      value={value}
      variant="standard"
      onChange={handleChange}
    />
  )
}

export default ContainerSearchInput
